/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Languageskillsen_Label3Inputs */

const en_cv_extract_form_languageskillsen_label3 = /** @type {(inputs: Cv_Extract_Form_Languageskillsen_Label3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English language skills`)
};

const de_cv_extract_form_languageskillsen_label3 = /** @type {(inputs: Cv_Extract_Form_Languageskillsen_Label3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englische Sprachkenntnisse`)
};

/**
* | output |
* | --- |
* | "English language skills" |
*
* @param {Cv_Extract_Form_Languageskillsen_Label3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_languageskillsen_label3 = /** @type {((inputs?: Cv_Extract_Form_Languageskillsen_Label3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Languageskillsen_Label3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_languageskillsen_label3(inputs)
	return en_cv_extract_form_languageskillsen_label3(inputs)
});
export { cv_extract_form_languageskillsen_label3 as "cv_extract_form_languageSkillsEN_label" }